import { ContentWrapper } from '../../../themes/styles/plan-overview';
import { GoalOverviewContentProps } from '../../../common/types/plan-overview-entity';
import { ProbabilityOfSuccessSection } from '../ProbabilityOfSuccessSection/ProbabilityOfSuccessSection';
import { PortfolioCompositionSection } from '../PortfolioCompositionSection/PortfolioCompositionSection';
import { GoalDetailsSection } from '../GoalDetailsSection/GoalDetailsSection';
import { checkFFEnabled } from '../../../utils';
import { FEATURE_NAMES } from '../../../common/constants';

export const GoalOverviewContent = ({ selectedGoalIndex }: GoalOverviewContentProps) => {
    const isPlanDetailsEnhancementEnabled = checkFFEnabled(FEATURE_NAMES['PLAN_DETAILS_ENHANCEMENT_FE_AEX-2554']);
    return (
        <ContentWrapper isPlanDetailsEnhancementEnabled={isPlanDetailsEnhancementEnabled}>
            <ProbabilityOfSuccessSection selectedGoalIndex={selectedGoalIndex} />
            <PortfolioCompositionSection selectedGoalIndex={selectedGoalIndex} />
            <GoalDetailsSection selectedGoalIndex={selectedGoalIndex} />
        </ContentWrapper>
    );
};
